import React from "react";

interface DetailsContainerProps {
  title: string;
  isRequired?: boolean;
  description?: string;
  headerComponent?: React.ReactNode;
}

export const DetailsContainer: React.FC<
  React.PropsWithChildren<DetailsContainerProps>
> = ({ title, description, children, isRequired = false, headerComponent }) => {
  return (
    <div className="text-default flex w-full flex-col gap-2 rounded-md">
      <div className="flex flex-col gap-1">
        <div className="flex flex-row justify-between gap-2 font-semibold">
          <div className="flex gap-1">
            <span>
              {title}&nbsp;
              {isRequired && <span className="text-rose">*</span>}
            </span>
          </div>
          <div className="flex flex-1 justify-end">{headerComponent}</div>
        </div>
        {description && <span className="text-muted">{description}</span>}
      </div>
      {children}
    </div>
  );
};
